"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploaderButton = void 0;
var _react = require("react");
var _Button = require("../../Button");
var _Uploader = require("../Uploader.labels");
var _hooks = require("../../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "onClick", "onFileChange", "styles", "inputAcceptanceTypes", "errorMessage"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var UploaderButton = /*#__PURE__*/(0, _react.forwardRef)(function (props, fileInputRef) {
  var children = props.children,
    onClick = props.onClick,
    onFileChange = props.onFileChange,
    styles = props.styles,
    inputAcceptanceTypes = props.inputAcceptanceTypes,
    errorMessage = props.errorMessage,
    rest = _objectWithoutProperties(props, _excluded);
  var getLabel = (0, _hooks.useLabels)({
    labels: _Uploader.labels
  });
  if (!onClick) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, _objectSpread(_objectSpread({
      id: "ccUploadButton"
    }, rest), {}, {
      onClick: onClick,
      children: children
    })), errorMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Uploader__error'],
      children: errorMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ref: fileInputRef,
      type: "file",
      className: styles['cc-Uploader__hidden-input'],
      accept: inputAcceptanceTypes,
      onChange: onFileChange,
      "aria-label": getLabel('upload_file')
    })]
  });
});
exports.UploaderButton = UploaderButton;